import { Directive, ElementRef, inject, OnInit, Input } from '@angular/core';
import { NeetoCal } from '../services/neeto-cal/neeto-cal.service';

@Directive({
  standalone: true,
  selector: '[appNeetoCalTrigger]',
})
export class NeetoCalTriggerDirective implements OnInit {
  private readonly el = inject(ElementRef<HTMLElement>);
  private readonly svc = inject(NeetoCal);

  @Input('appNeetoCalTrigger') contextMessage?: string;

  ngOnInit(): void {
    const elem = this.el.nativeElement;

    if (!elem.id) {
      elem.id = `neetocal-${Math.random().toString(36).slice(2, 8)}`;
    }

    void this.svc.registerButtons([{ elementId: elem.id, contextMessage: this.contextMessage }]);
  }
}
